/* eslint-disable */
import Actuator from '@/models/Actuator';
import actuatorService from "@/services/actuator.gasPneumatic.service";
import { findValidActuatorAtMinPressure, checkValidActuatorAtMaxPressure } from "@/services/actuator.acp.table-values.service";
import acpBasis from "@/services/acp.basis.service";

const getMasterACP = (data: Actuator): any => {
    const securityFactorsTorques = {
        bto: data.btoSecFac,
        btoRunning: data.runningSecFac,
        eto: data.etoSecFac,
        btc: data.btcSecFac,
        btcRunning: data.runningOutSecFac,
        etc: data.etcSecFac
    };

    const actuatorAngles = {
        bto: data.btoAngle,
        btoRunning: data.runningAngle,
        eto: data.etoAngle,
        btc: data.btcAngle,
        btcRunning: data.runningOutAngle,
        etc: data.etcAngle
    };

    const torques = {
        bto: data.bto,
        btoRunning: data.running,
        eto: data.eto,
        btc: data.btc,
        btcRunning: data.runningOut,
        etc: data.etc
    };

    const winkelKraftObject = actuatorService.setWinkelkraft(torques, securityFactorsTorques, actuatorAngles);
    actuatorService.setKlappe();

    const controlType = data.controlType;
    const driveTypeA = data.driveTypeA;
    const driveType = data.driveType;
    const minBar = data.pressureMin;
    const maxBar = data.pressureMax;
    const MAST = data.mast;
    const tolerance = data.tolerance;
    const items = data.items;

    let minMaxBar: number[];

    if (MAST) {
        minMaxBar = [minBar, maxBar];
    } else {
        minMaxBar = [minBar, minBar + 0.5];
    }

    const dynKnickwinkel = (driveTypeA === 'ACP') ? 0 : 12;

    for (let antriebIndex = 0; antriebIndex < acpBasis.ANTRIEBE_ARRAY.length; antriebIndex++) {
        const maxErlaubteDrehmoment = actuatorService.setMaxNettoAntrieb(antriebIndex, tolerance, driveTypeA);

        const optiMIN = findActuatorCandidateAtMinPressure(
            dynKnickwinkel,
            antriebIndex,
            controlType,
            driveTypeA,
            driveType,
            items,
            minMaxBar[0],
            maxErlaubteDrehmoment,
            winkelKraftObject
        );

        if (optiMIN !== undefined) {
            const optiMAX = checkActuatorCandidateAtMaxPressure(
                dynKnickwinkel,
                optiMIN.antriebsIndex,
                controlType,
                driveTypeA,
                driveType,
                optiMIN?.zylIndex || 0,
                optiMIN?.federIndex || 0,
                items,
                minMaxBar[1],
                maxErlaubteDrehmoment,
                winkelKraftObject
            );

            if (optiMAX !== undefined) {
                optiMIN.mast = { ...optiMAX };
                return {
                    found: true,
                    antrieb: optiMIN
                };
            }
        }
    }

    return {
        found: false,
        antrieb: undefined,
        reason: 'no actuator found'
    };
};

const findActuatorCandidateAtMinPressure = (
    dynKnickwinkel: number,
    antriebIndex: number,
    controlType: string,
    driveTypeA: string,
    driveType: string,
    items: number,
    minBar: number,
    maxNetActuatorTorque: number,
    winkelKraftObject: any
) => {
    return findValidActuatorAtMinPressure(
        { winkelKraftObject },
        dynKnickwinkel,
        antriebIndex,
        controlType,
        driveTypeA,
        driveType,
        items,
        minBar,
        maxNetActuatorTorque
    );
};

const checkActuatorCandidateAtMaxPressure = (
    dynKnickwinkel: number,
    antriebIndex: number,
    controlType: string,
    driveTypeA: string,
    driveType: string,
    zylIndex: number,
    federIndex: number,
    items: number,
    maxBar: number,
    maxNetActuatorTorque: number,
    winkelKraftObject: any
) => {
    return checkValidActuatorAtMaxPressure(
        { winkelKraftObject },
        dynKnickwinkel,
        antriebIndex,
        controlType,
        driveTypeA,
        driveType,
        zylIndex,
        federIndex,
        items,
        maxBar,
        maxNetActuatorTorque
    );
};

const actuatorAcpService = {
    getMasterACP
};

export default actuatorAcpService;
